{
  "about": {
    "paragraph": "私たちはAGEC法の課題に対処し、お客様に製品の原産地と環境品質について情報を提供することに取り組んでいます。",
    "title": "概要"
  },
  "lastUpdate": "最終更新日: ",
  "loading": {
    "dataPending": "現在この情報を収集中です",
    "pendingLocation": "場所待機中"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "アパレル製造",
    "FOOTWEAR_FINISHING": "履物仕上げ",
    "FOOTWEAR_STITCHING": "履物縫製",
    "FOOTWEAR_ASSEMBLING": "履物組立",
    "FABRIC_WEAVING_OR_KNITTING": "織物または編物",
    "FABRIC_DYEING_PRINTING": "織物染色またはプリント",
    "YARN_PROVIDER": "糸供給業者",
    "YARN_DYEING_PRINTING": "糸染色またはプリント",
    "LEATHER_TANNING": "皮革なめし",
    "LEATHER_DYEING_PRINTING": "皮革染色またはプリント",
    "ACCESSORY_PROVIDER": "アクセサリー供給業者",
    "YARN_MATERIAL_PRODUCTION": "糸材料生産",
    "FABRIC_SPINNING": "織物紡績",
    "FABRIC_MATERIAL_PRODUCTION": "織物材料生産",
    "LEATHER_MATERIAL_PRODUCTION": "皮革材料生産",
    "LEATHER_FARM": "繁殖農場",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "アクセサリー原材料供給業者",
    "COATING": "コーティング"
  },
  "other": {
    "microplastics_bold": "マイクロプラスチックを放出します ",
    "paragraph1": "この製品には ",
    "paragraph1_100": "この製品には100%リサイクル材料が含まれています。",
    "paragraph2_1": "この製品は ",
    "paragraph2_2": "  洗濯中に環境に放出します: ",
    "paragraph2_3": "製品の質量のうち合成繊維で構成されています。",
    "paragraph3": "アプリケーションにおける有害物質の潜在的な存在に関する情報: ",
    "recycled_matertials_bold": "少なくとも{{percent}}%のリサイクル材料。",
    "recycled_matertials_bold_50": "50%以上 ",
    "title": "その他の環境品質と特徴"
  },
  "packaging": {
    "recyclable": "リサイクル可能: 包装はリサイクル可能です。",
    "recycled": "リサイクル材料: 包装には少なくとも{{percent}}%のリサイクル材料が含まれています。",
    "recycled_100": "リサイクル材料: 包装には100%リサイクル材料が含まれています。",
    "title": "包装の環境品質と特徴"
  },
  "title": "環境品質または特性に関する製品シート",
  "traceability": {
    "paragraph": "これは、製品の作成から主要材料の織物と染色まで、最初の3つの生産段階における製品の原産地を指します。",
    "title": "製品トレーサビリティ"
  },
  "ecoScore": {
    "title": "エコスコア"
  }
}
